import axios from 'axios';

const getList = params => axios.get('requisicoes/aprovacoes', { params });

const get = id => axios.get(`requisicoes/aprovacoes/${id}`);

const getProduto = (id, idProduto) => axios.get(`requisicoes/aprovacoes/${id}/produtos/${idProduto}`);

const aprovarProdutos = (idAprovacao, data) => axios.put(`requisicoes/aprovacoes/${idAprovacao}/aprovar`, data);

const recusarProdutos = (idAprovacao, data) => axios.put(`requisicoes/aprovacoes/${idAprovacao}/recusar`, data);

const getLinks = id => axios.get(`/requisicoes/aprovacoes/${id}/links`);

const gerarSolicitacaoProdutos = (id, data) => axios.put(`requisicoes/aprovacoes/${id}/gerar-requisicao`, data);

export default {
  get,
  getProduto,
  getList,
  getLinks,
  aprovarProdutos,
  recusarProdutos,
  gerarSolicitacaoProdutos,
};
